import { useTranslation } from 'react-i18next';
import { FaPhoneVolume } from "react-icons/fa6";
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import logoAr from 'src/assets/images/navbar/logo_ar.svg';
import logoEn from 'src/assets/images/navbar/logo_en.svg';
import logoIt from 'src/assets/images/navbar/logo_it.svg';
import { isRTL } from 'src/utils/global';
import styles from './styles.module.css';

const NavLarge = () => {
    const { t, i18n } = useTranslation('common');

    const getLinkClassName = ({ isActive }: { isActive: boolean }) =>
        `${styles.item__link} nav-link ${isActive ? styles.active : ''}`;

    const getSubLinkClassName = ({ isActive }: { isActive: boolean }) =>
        `${styles.dropdownItem} dropdown-item ${isActive ? styles.active : ''}`;

    // ✅ Select logo dynamically
    const currentLang = i18n.language;
    const logo =
        currentLang === 'ar'
            ? logoAr
            : currentLang === 'it'
                ? logoIt
                : logoEn;

    return (
        <header>
            <Navbar expand="xl" className={`${styles.nav} ${isRTL() && styles.rtl}`}>
                <Container className={styles.navContainer}>
                    {/* Logo */}
                    <Navbar.Brand href="/" className={styles.navBrand}>
                        <img src={logo} alt={t('nav.title')} />
                    </Navbar.Brand>

                    {/* Toggle for mobile */}
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />

                    {/* Links */}
                    <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
                        <Nav className={styles.navLinks}>
                            <NavLink to="/" className={getLinkClassName}>
                                {t('nav.home')}
                            </NavLink>

                            <NavDropdown
                                dir={isRTL() ? 'rtl' : 'ltr'}
                                title={t('nav.products')}
                                id="basic-nav-dropdown"
                                className={styles.dropdown__menu}
                            >
                                <NavLink to="/supplements" className={getSubLinkClassName}>
                                    {t('nav.supplements')}
                                </NavLink>
                                <a className="dropdown-item disabled">
                                    {t('nav.supplies')}
                                </a>
                            </NavDropdown>

                            <NavLink to="/about" className={getLinkClassName}>
                                {t('nav.about')}
                            </NavLink>

                            {/* 🟢 Contact Us as a button */}
                            <div className={styles.contactWrapper}>
                                <NavLink to="/contact" className={styles.contactButton}>
                                    {t('nav.contact')}<FaPhoneVolume />
                                </NavLink>
                            </div>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    );
};

export default NavLarge;
